import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface ObjectOnReviewDialogProps {
  onConfirm: () => void
}

export const ObjectOnReviewDialog = ({
  onConfirm,
}: ObjectOnReviewDialogProps) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={clsx('bold-20', s.title)}>
          {t('kyrgyzstan_block.edit_object.review_dialog.title')}
        </p>
        <p className={clsx('regular-14', s.description)}>
          {t('kyrgyzstan_block.edit_object.review_dialog.description')}
        </p>
      </div>

      <div className={s.buttonContainer}>
        <Button
          type="button"
          borderRadius="nr"
          className={clsx('bold-17', s.button)}
          onClick={onConfirm}
        >
          {t('kyrgyzstan_block.edit_object.review_dialog.confirm')}
        </Button>
      </div>
    </div>
  )
}
